// ANCHOR React Icons Kit
import { Icon } from 'react-icons-kit';

// ANCHOR Models
import {
  useFormSubmissionQuestionItemState,
  useFormSubmissionQuestionItemFinalScore,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';
import { useFormData } from '@lyon/scoped-models/form/FormData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Styles
import { ICON } from './styles';

// ANCHOR Constants
import { STATE_ICON } from './constants';

export const LyonViewAnswerFormQuestionStatusIcon = constant(() => {
  const answerState = useFormSubmissionQuestionItemState();
  const form = useFormData();
  const finalScore = useFormSubmissionQuestionItemFinalScore();

  const showAfterRegrade = form?.showAfterRegrade
    ? finalScore != null
    : true;

  if (form?.showCorrectResponse && showAfterRegrade) {
    return (
      <Icon
        size={24}
        icon={STATE_ICON[answerState]}
        style={ICON[answerState]}
      />
    );
  }

  return null;
});
